module.exports = __webpack_public_path__ + "img/声光警告.6a1cf8ae.jpg";